// extracted by mini-css-extract-plugin
export var amount = "planCard-module--amount--e08ed";
export var cardContents = "planCard-module--cardContents--a82f6";
export var collapsible = "planCard-module--collapsible--3e71c";
export var collapsibleContainer = "planCard-module--collapsibleContainer--3b70c";
export var description = "planCard-module--description--1b46a";
export var desktop = "planCard-module--desktop--cfc9c";
export var divider = "planCard-module--divider--dc6e5";
export var emailSendsContainer = "planCard-module--emailSendsContainer--f31b1";
export var emailSendsPlusContainer = "planCard-module--emailSendsPlusContainer--640e3";
export var emailSendsText = "planCard-module--emailSendsText--8f434";
export var iconDown = "planCard-module--iconDown--cc326";
export var iconUp = "planCard-module--iconUp--96690";
export var mobile = "planCard-module--mobile--9e56d";
export var planCard = "planCard-module--planCard--68755";
export var planName = "planCard-module--planName--6d9e1";
export var planNameContainer = "planCard-module--planNameContainer--2a694";
export var priceWrapper = "planCard-module--priceWrapper--f99d6";
export var recommended = "planCard-module--recommended--18ffd";
export var recommendedText = "planCard-module--recommendedText--20dce";
export var smsSubText = "planCard-module--smsSubText--11b78";
export var statsContainer = "planCard-module--statsContainer--c35d2";
export var text = "planCard-module--text--2395a";
export var timePeriod = "planCard-module--timePeriod--99aa5";